class DisplayAnimation {
  /**
   * Fade in
   * @param {HTMLElement} node フェードイン要素
   * @param {number} duration アニメーションの時間
   * @returns
   */
  fadeIn(node, duration = 300) {
    if (getComputedStyle(node).display !== "none") return;
    if (node.style.display === "none") {
      node.style.display = "";
    } else {
      node.style.display = "block";
    }
    node.style.opacity = 0;
    const start = performance.now();
    requestAnimationFrame(function tick(timestamp) {
      const easing = (timestamp - start) / duration;
      node.style.opacity = Math.min(easing, 1);
      if (easing < 1) {
        requestAnimationFrame(tick);
      } else {
        node.style.opacity = "";
      }
    });
  }
  /**
   * Fade out
   * @param {HTMLElement} node フェードアウト要素
   * @param {number} duration アニメーションの時間
   */
  fadeOut(node, duration = 300) {
    node.style.opacity = 1;
    const start = performance.now();
    requestAnimationFrame(function tick(timestamp) {
      const easing = (timestamp - start) / duration;
      node.style.opacity = Math.max(1 - easing, 0);
      if (easing < 1) {
        requestAnimationFrame(tick);
      } else {
        node.style.opacity = "";
        node.style.display = "none";
      }
    });
  }
}
const BODY = document.body;
const HEADER = document.getElementById("js-header");
const HAMBURGER = document.getElementById("js-hamburgerBtn");
const FULL_SCREEN_OVERLAY = document.getElementById("js-fullScreenOverlay");
const FLOATING_BTN = document.getElementById("js-floatingMenu");
const TO_TOP = document.getElementById("js-toTop");
const CSS_CAN_SCROLL = "js-canScroll";
const displayAnimation = new DisplayAnimation();
function openFullScreenOverlay() {
  if (FULL_SCREEN_OVERLAY) {
    displayAnimation.fadeIn(FULL_SCREEN_OVERLAY, 100);
    FULL_SCREEN_OVERLAY.classList.add("is-show");
  }
}
function closeFullScreenOverlay() {
  if (FULL_SCREEN_OVERLAY) {
    displayAnimation.fadeOut(FULL_SCREEN_OVERLAY, 100);
    FULL_SCREEN_OVERLAY.classList.remove("is-show");
  }
}
function focusToButton(parentElement, isFirstFocus = true) {
  if (!parentElement) {
    throw new Error("要素が見つかりませんでした");
  }
  const focusableArray = createInteractiveElArray(parentElement);
  if (focusableArray.length > 0) {
    focusableArray[isFirstFocus ? 0 : focusableArray.length - 1].focus();
  }
  focusableArray[0].focus();
}
function modalFocus(event, parentElement, onClose) {
  if (!parentElement) {
    return;
  }
  switch (event.code) {
    case "Enter":
    case "Space":
      break;
    case "Escape":
      onClose();
      break;
    case "Tab": {
      const interactiveElArray = createInteractiveElArray(parentElement);
      const focusIndex = interactiveElArray.findIndex((el) => el === document.activeElement);
      if (interactiveElArray.length === 1) {
        event.preventDefault();
        event.stopImmediatePropagation();
        focusToButton(parentElement, true);
        break;
      }
      if (focusIndex === 0) {
        if (event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          focusToButton(parentElement, false);
        }
      } else if (focusIndex >= interactiveElArray.length - 1) {
        if (!event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          focusToButton(parentElement, true);
        }
      } else if (focusIndex === -1) {
        focusToButton(parentElement, true);
      }
      break;
    }
  }
}
function createInteractiveElArray(element) {
  const INTERACTIVE_SELECTOR = "button, a";
  const elements = element.querySelectorAll(INTERACTIVE_SELECTOR);
  const interactiveElArray = Array.from(elements);
  return interactiveElArray;
}
function scrollLock(event) {
  var _a;
  const canScrollElement = (_a = event.target) == null ? void 0 : _a.closest(CSS_CAN_SCROLL);
  if (canScrollElement === null) {
    event.preventDefault();
    return;
  }
  if (canScrollElement && isScrollable(canScrollElement)) {
    event.stopPropagation();
  } else {
    event.preventDefault();
  }
}
function scrollLockFix(element) {
  if (isWindows()) {
    scrollLockFixWindows();
  } else {
    BODY.classList.add("is-scrollLock");
  }
  const canScrollElement = element.querySelector(CSS_CAN_SCROLL);
  if (!canScrollElement) {
    return;
  }
  canScrollElement.addEventListener("scroll", scrollLockTroubleShooting);
}
function scrollLockFixRemove(element) {
  if (isWindows()) {
    scrollLockFixRemoveWindows();
  } else {
    BODY.classList.remove("is-scrollLock");
  }
  const canScrollElement = element.querySelector(CSS_CAN_SCROLL);
  if (!canScrollElement) {
    return;
  }
  canScrollElement.removeEventListener("scroll", scrollLockTroubleShooting);
}
function isScrollable(element) {
  return element.clientHeight < element.scrollHeight;
}
function scrollLockTroubleShooting(event) {
  const element = event.target;
  if (element === null) {
    return;
  }
  if (element.scrollTop + element.clientHeight === element.scrollHeight) {
    element.scrollTop = element.scrollTop - 1;
  }
  if (element.scrollTop === 0) {
    element.scrollTop = 1;
  }
}
function isWindows() {
  return window.navigator.userAgent.toLowerCase().indexOf("windows nt") !== -1;
}
let scrollPos = 0;
function scrollLockFixWindows() {
  scrollPos = document.documentElement.scrollTop || BODY.scrollTop;
  BODY.classList.add("is-scrollLock-windows");
  BODY.style.top = `-${scrollPos}px`;
}
function scrollLockFixRemoveWindows() {
  BODY.classList.remove("is-scrollLock-windows");
  BODY.style.top = "initial";
  BODY.scrollTop = scrollPos;
  document.documentElement.scrollTop = scrollPos;
}
const nav = document.getElementById("js-globalNav");
function drawerDisplayControl() {
  if (nav) {
    if (isDrawerOpen()) {
      closeDrawerMenu();
      closeFullScreenOverlay();
    } else {
      openDrawerMenu();
      openFullScreenOverlay();
    }
  }
}
function focusHandleMenu(event) {
  modalFocus(event, nav, close);
}
function openDrawerMenu() {
  if (HEADER) HEADER.classList.add("is-open");
  if (HAMBURGER) HAMBURGER.classList.add("is-open");
  window.addEventListener("keydown", focusHandleMenu, { capture: true });
  document.addEventListener("touchmove", scrollLock, { passive: false });
  scrollLockFix(nav);
  focusToButton(nav);
}
const closeDrawerMenu = () => {
  if (HEADER) HEADER.classList.remove("is-open");
  if (HAMBURGER) HAMBURGER.classList.remove("is-open");
  window.removeEventListener("keydown", focusHandleMenu, { capture: true });
  document.removeEventListener("touchmove", scrollLock);
  scrollLockFixRemove(nav);
  if (HAMBURGER) HAMBURGER.focus();
};
const isDrawerOpen = () => {
  return HEADER.classList.contains("is-open");
};
const FADE_IN_TOP = 800;
function floatingMenuDisplayControl() {
  let currentTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (currentTop && FLOATING_BTN) {
    if (currentTop >= FADE_IN_TOP) {
      FLOATING_BTN.setAttribute("aria-hidden", false);
    } else {
      FLOATING_BTN.setAttribute("aria-hidden", true);
    }
  }
}
function toTop() {
  window.scroll({
    top: 0,
    behavior: "smooth"
  });
}
function linkWithinPageControl() {
  const scrollLink = document.querySelectorAll('a[href^="#"]');
  if (scrollLink !== null) {
    for (let i = 0; i < scrollLink.length; i++) {
      scrollLink[i].addEventListener("click", scrollToAnchor.bind(scrollLink[i]), false);
    }
  }
}
function scrollToAnchor(e) {
  const hash = this.hash;
  if (hash !== "#" && hash !== "") {
    e.preventDefault();
    e.stopPropagation();
    const targetElement = document.getElementById(hash.replace("#", ""));
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    const gap = HEADER.offsetHeight;
    const y = rect + offset - gap;
    window.scroll({
      top: y,
      behavior: "smooth"
    });
  }
}
class OriginalDetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.details.querySelector("summary");
    this.content = this.summary.nextElementSibling;
    this.summary.addEventListener("click", this.toggleDetails.bind(this));
  }
  toggleDetails(event) {
    event.preventDefault();
    if (this.details.hasAttribute("open")) {
      this.closeDetails();
    } else {
      this.openDetails();
    }
  }
  openDetails() {
    this.details.setAttribute("open", "true");
    this.details.classList.add("is-open");
    this.content.animate(this.openingAnimation(), this.animationSettings());
  }
  closeDetails() {
    this.details.classList.remove("is-open");
    const closingAnim = this.content.animate(this.closingAnimation(), this.animationSettings());
    closingAnim.onfinish = () => {
      this.details.removeAttribute("open");
    };
  }
  openingAnimation() {
    return [
      { height: "0px", opacity: 0 },
      { height: `${this.content.scrollHeight}px`, opacity: 1 }
    ];
  }
  closingAnimation() {
    return [
      { height: `${this.content.scrollHeight}px`, opacity: 1 },
      { height: "0px", opacity: 0 }
    ];
  }
  animationSettings() {
    return {
      duration: 300,
      easing: "ease"
    };
  }
}
customElements.define("original-details-disclosure", OriginalDetailsDisclosure);
class OriginalDialog extends HTMLElement {
  constructor() {
    super();
    this.dialogElement = this.querySelector(".js-dialog");
    this.toggleButtons = this.querySelectorAll(".js-dialogToggle");
    this.dialogElement.addEventListener("click", (event) => {
      if (event.target === this.dialogElement) {
        this.toggleDialog();
      }
    });
    this.toggleButtons.forEach((button) => {
      button.addEventListener("click", this.toggleDialog.bind(this));
    });
  }
  /**
   * Toggle dialog visibility based on its current state
   */
  toggleDialog() {
    if (this.isDialogOpen()) {
      this.closeDialog();
    } else {
      this.openDialog();
    }
  }
  /**
   * Check if the dialog is currently open
   * @returns {Boolean} True if the dialog is open
   */
  isDialogOpen() {
    return this.dialogElement.hasAttribute("open");
  }
  /**
   * Open the dialog and add necessary event listeners
   */
  openDialog() {
    if (typeof this.dialogElement.showModal === "function") {
      this.dialogElement.showModal();
    } else {
      console.error("The <dialog> API is not supported by this browser");
    }
  }
  /**
  * Close the dialog and remove event listeners
  */
  closeDialog() {
    this.dialogElement.close();
  }
}
customElements.define("original-dialog", OriginalDialog);
class OriginalFaq extends HTMLElement {
  constructor() {
    super();
    this._items = [];
  }
  connectedCallback() {
    this._items = Array.from(this.querySelectorAll(".js-faq-details"));
    this._items.forEach((details) => this._setupItem(details));
  }
  _setupItem(details) {
    const summary = details.querySelector(".js-faq-question");
    const wrapper = details.querySelector(".js-faq-answer-wrapper");
    if (!summary || !wrapper) return;
    const setHeight = (height) => {
      wrapper.style.height = height === "" ? "" : height + "px";
    };
    const setInitialState = () => {
      if (details.open) {
        details.classList.add("is-expanded");
        wrapper.classList.add("is-open");
        setHeight("");
      } else {
        details.classList.remove("is-expanded");
        wrapper.classList.remove("is-open");
        wrapper.classList.remove("is-collapsing");
        setHeight(0);
      }
    };
    setInitialState();
    summary.addEventListener("click", (e) => {
      e.preventDefault();
      if (wrapper.classList.contains("is-collapsing")) return;
      if (details.open) {
        this._close(details, wrapper, setHeight);
      } else {
        this._open(details, wrapper, setHeight);
      }
    });
  }
  _close(details, wrapper, setHeight) {
    details.classList.remove("is-expanded");
    const startHeight = wrapper.offsetHeight;
    wrapper.style.height = startHeight + "px";
    wrapper.offsetHeight;
    wrapper.classList.add("is-collapsing");
    wrapper.classList.remove("is-open");
    setHeight(0);
    wrapper.addEventListener(
      "transitionend",
      () => {
        wrapper.classList.remove("is-collapsing");
        setHeight("");
        details.removeAttribute("open");
      },
      { once: true }
    );
  }
  _open(details, wrapper, setHeight) {
    details.setAttribute("open", "");
    details.classList.add("is-expanded");
    wrapper.classList.add("is-collapsing");
    setHeight(0);
    wrapper.offsetHeight;
    const endHeight = wrapper.scrollHeight;
    setHeight(endHeight);
    wrapper.addEventListener(
      "transitionend",
      () => {
        wrapper.classList.remove("is-collapsing");
        wrapper.classList.add("is-open");
        setHeight("");
      },
      { once: true }
    );
  }
}
customElements.define("original-faq", OriginalFaq);
const FOOTER_ACCORDION_MQ_MOBILE = "(max-width: 999px)";
class OriginalFooterAccordion extends HTMLElement {
  constructor() {
    super();
    this._details = null;
    this._summary = null;
    this._wrapper = null;
    this._isMobileMedia = null;
    this._onSummaryClick = this._handleSummaryClick.bind(this);
    this._onSummaryKeydown = this._handleSummaryKeydown.bind(this);
    this._onDetailsToggle = this._handleDetailsToggle.bind(this);
    this._onMediaChange = this._handleMediaChange.bind(this);
  }
  connectedCallback() {
    this._details = this.querySelector(".js-footer-details");
    this._summary = this.querySelector(".js-footer-summary");
    this._wrapper = this.querySelector(".js-footer-content-wrapper");
    if (!this._details || !this._summary || !this._wrapper) return;
    this._isMobileMedia = window.matchMedia(FOOTER_ACCORDION_MQ_MOBILE);
    this._summary.addEventListener("click", this._onSummaryClick);
    this._summary.addEventListener("keydown", this._onSummaryKeydown);
    this._details.addEventListener("toggle", this._onDetailsToggle);
    this._isMobileMedia.addEventListener("change", this._onMediaChange);
    this._applyMode();
  }
  disconnectedCallback() {
    if (this._summary) {
      this._summary.removeEventListener("click", this._onSummaryClick);
      this._summary.removeEventListener("keydown", this._onSummaryKeydown);
    }
    if (this._details) {
      this._details.removeEventListener("toggle", this._onDetailsToggle);
    }
    if (this._isMobileMedia) {
      this._isMobileMedia.removeEventListener("change", this._onMediaChange);
    }
  }
  _handleMediaChange() {
    this._applyMode();
  }
  _applyMode() {
    if (this._isMobileMedia.matches) {
      this._setMobileState();
      return;
    }
    this._setDesktopState();
  }
  _setDesktopState() {
    this._details.setAttribute("open", "");
    this._details.classList.add("is-expanded");
    this._wrapper.classList.remove("is-collapsing");
    this._wrapper.classList.add("is-open");
    this._summary.setAttribute("aria-expanded", "true");
    this._setHeight("");
  }
  _setMobileState() {
    this._details.removeAttribute("open");
    this._details.classList.remove("is-expanded");
    this._wrapper.classList.remove("is-open");
    this._wrapper.classList.remove("is-collapsing");
    this._summary.setAttribute("aria-expanded", "false");
    this._setHeight(0);
  }
  _setHeight(height) {
    this._wrapper.style.height = height === "" ? "" : height + "px";
  }
  _runAfterTransition(callback) {
    let isHandled = false;
    const done = () => {
      if (isHandled) return;
      isHandled = true;
      callback();
    };
    this._wrapper.addEventListener("transitionend", done, { once: true });
    window.setTimeout(done, 420);
  }
  /**
   * PC幅では <summary> の既定動作（details の開閉）を必ず止め、常に展開に固定する
   */
  _handleSummaryClick(event) {
    if (!this._isMobileMedia.matches) {
      event.preventDefault();
      this._setDesktopState();
      return;
    }
    event.preventDefault();
    if (this._details.open) {
      this._close();
      return;
    }
    this._open();
  }
  /**
   * キーボード操作でも PC 時は開閉させない（Enter / Space）
   */
  _handleSummaryKeydown(event) {
    if (this._isMobileMedia.matches) return;
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    this._setDesktopState();
  }
  /**
   * フォーカスや他要因で details が閉じた場合も PC では即復帰
   */
  _handleDetailsToggle() {
    if (this._isMobileMedia.matches) return;
    if (!this._details.open) {
      this._setDesktopState();
    }
  }
  _close() {
    this._details.classList.remove("is-expanded");
    const startHeight = this._wrapper.offsetHeight;
    this._wrapper.style.height = startHeight + "px";
    this._wrapper.offsetHeight;
    this._wrapper.classList.add("is-collapsing");
    this._wrapper.classList.remove("is-open");
    this._summary.setAttribute("aria-expanded", "false");
    this._setHeight(0);
    this._runAfterTransition(() => {
      this._wrapper.classList.remove("is-collapsing");
      this._setHeight("");
      this._details.removeAttribute("open");
    });
  }
  _open() {
    this._details.setAttribute("open", "");
    this._details.classList.add("is-expanded");
    this._wrapper.classList.add("is-collapsing");
    this._summary.setAttribute("aria-expanded", "true");
    this._setHeight(0);
    this._wrapper.offsetHeight;
    const endHeight = this._wrapper.scrollHeight;
    this._setHeight(endHeight);
    this._runAfterTransition(() => {
      this._wrapper.classList.remove("is-collapsing");
      this._wrapper.classList.add("is-open");
      this._setHeight("");
    });
  }
}
customElements.define("original-footer-accordion", OriginalFooterAccordion);
class OriginalHeaderDrawerAccordion extends HTMLElement {
  constructor() {
    super();
    this._details = null;
    this._summary = null;
    this._wrapper = null;
    this._onSummaryClick = this._handleSummaryClick.bind(this);
  }
  connectedCallback() {
    this._details = this.querySelector(".js-header-drawer-details");
    this._summary = this.querySelector(".js-header-drawer-trigger");
    this._wrapper = this.querySelector(".js-header-drawer-content");
    if (!this._details || !this._summary || !this._wrapper) return;
    this._summary.addEventListener("click", this._onSummaryClick);
    this._initializeState();
  }
  disconnectedCallback() {
    if (this._summary) {
      this._summary.removeEventListener("click", this._onSummaryClick);
    }
  }
  _initializeState() {
    this._details.removeAttribute("open");
    this._details.classList.remove("is-open");
    this._wrapper.classList.remove("is-open");
    this._wrapper.classList.remove("is-collapsing");
    this._summary.setAttribute("aria-expanded", "false");
    this._setHeight(0);
  }
  _setHeight(height) {
    this._wrapper.style.height = height === "" ? "" : height + "px";
  }
  _runAfterTransition(callback) {
    let isHandled = false;
    const done = () => {
      if (isHandled) return;
      isHandled = true;
      callback();
    };
    this._wrapper.addEventListener("transitionend", done, { once: true });
    window.setTimeout(done, 420);
  }
  _handleSummaryClick(event) {
    event.preventDefault();
    if (this._details.open) {
      this._close();
      return;
    }
    this._open();
  }
  _close() {
    this._details.classList.remove("is-open");
    const startHeight = this._wrapper.offsetHeight;
    this._wrapper.style.height = startHeight + "px";
    this._wrapper.offsetHeight;
    this._wrapper.classList.add("is-collapsing");
    this._wrapper.classList.remove("is-open");
    this._summary.setAttribute("aria-expanded", "false");
    this._setHeight(0);
    this._runAfterTransition(() => {
      this._wrapper.classList.remove("is-collapsing");
      this._setHeight("");
      this._details.removeAttribute("open");
    });
  }
  _open() {
    this._details.setAttribute("open", "");
    this._details.classList.add("is-open");
    this._wrapper.classList.add("is-collapsing");
    this._summary.setAttribute("aria-expanded", "true");
    this._setHeight(0);
    this._wrapper.offsetHeight;
    const endHeight = this._wrapper.scrollHeight;
    this._setHeight(endHeight);
    this._runAfterTransition(() => {
      this._wrapper.classList.remove("is-collapsing");
      this._wrapper.classList.add("is-open");
      this._setHeight("");
    });
  }
}
customElements.define("original-header-drawer-accordion", OriginalHeaderDrawerAccordion);
document.addEventListener("DOMContentLoaded", () => {
  const closeButton = document.querySelector(".js-drawer-close");
  if (!closeButton) return;
  closeButton.addEventListener("click", (event) => {
    const headerDrawer = closeButton.closest("header-drawer");
    if (!headerDrawer) return;
    const mainDetailsToggle = headerDrawer.querySelector("details");
    const summaryElement = mainDetailsToggle == null ? void 0 : mainDetailsToggle.querySelector("summary");
    if (mainDetailsToggle && summaryElement) {
      headerDrawer.closeMenuDrawer(event, summaryElement);
    }
  });
});
class OriginalModal extends HTMLElement {
  constructor() {
    super();
    this.modalElement = this.querySelector(".js-modal");
    this.toggleButtons = this.querySelectorAll(".js-modalToggle");
    this.previousScrollPosition = 0;
    this.toggleButtons.forEach((button) => {
      button.addEventListener("click", this.toggleModal.bind(this));
    });
  }
  /**
   * Toggle modal visibility based on its current state
   */
  toggleModal() {
    if (this.isModalOpen()) {
      this.closeModal();
    } else {
      this.openModal();
    }
  }
  /**
   * Check if the modal is currently open
   * @returns {Boolean} True if the modal is open
   */
  isModalOpen() {
    return this.hasAttribute("open");
  }
  /**
   * Open the modal and add necessary event listeners
   */
  openModal() {
    this.setAttribute("open", "true");
    window.addEventListener("keydown", this.handleKeyboardFocus.bind(this), { capture: true });
    document.addEventListener("touchmove", this.preventScroll, { passive: false });
    this.fixScrollLock(this.modalElement);
    this.setFocusToFirstButton(this.modalElement);
  }
  /**
   * Close the modal and remove event listeners
   */
  closeModal() {
    this.removeAttribute("open");
    window.removeEventListener("keydown", this.handleKeyboardFocus.bind(this), { capture: true });
    document.removeEventListener("touchmove", this.preventScroll);
    this.removeScrollLockFix(this.modalElement);
    this.toggleButtons[0].focus();
  }
  /**
   * Handle keyboard interactions inside the modal
   */
  handleKeyboardFocus(event) {
    this.controlModalFocus(event, this.modalElement, this.closeModal.bind(this));
  }
  /**
   * Set focus to either the first or last button inside the modal
   * @param {DOM} parentElement The modal element
   * @param {Boolean} isFirstFocus Whether to focus on the first or last button
   */
  setFocusToFirstButton(parentElement, isFirstFocus = true) {
    if (!parentElement) {
      throw new Error("Modal element not found");
    }
    const focusableElements = this.getFocusableElements(parentElement);
    if (focusableElements.length > 0) {
      focusableElements[isFirstFocus ? 0 : focusableElements.length - 1].focus();
    }
  }
  /**
   * Control modal keyboard focus behavior (e.g., trapping focus, handling Escape)
   * @param {Event} event
   * @param {DOM} parentElement The modal element
   * @param {Function} onClose Function to close the modal
   */
  controlModalFocus(event, parentElement, onClose) {
    if (!parentElement) return;
    switch (event.code) {
      case "Enter":
      case "Space":
        break;
      case "Escape":
        onClose();
        break;
      case "Tab": {
        const focusableElements = this.getFocusableElements(parentElement);
        const currentIndex = focusableElements.findIndex((el) => el === document.activeElement);
        if (focusableElements.length === 1) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setFocusToFirstButton(parentElement, true);
        } else if (currentIndex === 0 && event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setFocusToFirstButton(parentElement, false);
        } else if (currentIndex >= focusableElements.length - 1 && !event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setFocusToFirstButton(parentElement, true);
        } else if (currentIndex === -1) {
          this.setFocusToFirstButton(parentElement, true);
        }
        break;
      }
    }
  }
  /**
   * Get all focusable elements within the modal
   * @param {DOM} modalElement The modal element
   * @returns {Array} An array of focusable elements
   */
  getFocusableElements(modalElement) {
    const focusableSelector = "button, a";
    return Array.from(modalElement.querySelectorAll(focusableSelector));
  }
  /**
   * Prevent scrolling on the document except for the modal
   * @param {Event} event The scroll event
   */
  preventScroll(event) {
    var _a;
    const isScrollableElement = (_a = event.target) == null ? void 0 : _a.closest(this.modalElement);
    if (!isScrollableElement || !this.isElementScrollable(isScrollableElement)) {
      event.preventDefault();
    } else {
      event.stopPropagation();
    }
  }
  /**
   * Fix scroll issues when modal is open
   * @param {DOM} modalElement The modal element
   */
  fixScrollLock(modalElement) {
    if (this.isWindows()) {
      this.applyWindowsScrollLock();
    } else {
      document.body.classList.add("is-scrollLock");
    }
    modalElement.addEventListener("scroll", this.handleScrollBug);
  }
  /**
   * Remove scroll lock fixes
   * @param {DOM} modalElement The modal element
   */
  removeScrollLockFix(modalElement) {
    if (this.isWindows()) {
      this.removeWindowsScrollLock();
    } else {
      document.body.classList.remove("is-scrollLock");
    }
    modalElement.removeEventListener("scroll", this.handleScrollBug);
  }
  /**
   * Check if the element is scrollable
   * @param {DOM} element The element to check
   * @returns {Boolean} True if the element is scrollable
   */
  isElementScrollable(element) {
    return element.clientHeight < element.scrollHeight;
  }
  /**
   * Handle scroll-related bugs in specific scenarios
   * @param {Event} event
   */
  handleScrollBug(event) {
    const element = event.target;
    if (!element) return;
    if (element.scrollTop + element.clientHeight === element.scrollHeight) {
      element.scrollTop -= 1;
    }
    if (element.scrollTop === 0) {
      element.scrollTop = 1;
    }
  }
  /**
   * Detect if the operating system is Windows
   * @returns {Boolean} True if the OS is Windows
   */
  isWindows() {
    return window.navigator.userAgent.toLowerCase().includes("windows nt");
  }
  /**
   * Apply scroll lock fix for Windows
   */
  applyWindowsScrollLock() {
    this.previousScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    document.body.classList.add("is-scrollLock-windows");
    document.body.style.top = `-${this.previousScrollPosition}px`;
  }
  /**
   * Remove scroll lock fix for Windows
   */
  removeWindowsScrollLock() {
    document.body.classList.remove("is-scrollLock-windows");
    document.body.style.top = "initial";
    document.body.scrollTop = this.previousScrollPosition;
    document.documentElement.scrollTop = this.previousScrollPosition;
  }
}
customElements.define("original-modal", OriginalModal);
class OriginalSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".js-slider");
    this.buttonPrev = this.querySelector(".js-sliderNavigationPrev");
    this.buttonNext = this.querySelector(".js-sliderNavigationNext");
    this.pagination = this.querySelector(".js-sliderPagination");
    this.sliderInstance = null;
  }
  initializeSlider(sliderOptions) {
    if (!this.slider) {
      console.error("Slider element not found.");
      return;
    }
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
    }
    this.sliderInstance = new Swiper(this.slider, {
      ...sliderOptions,
      ...this.buttonPrev && this.buttonNext ? {
        navigation: {
          nextEl: this.buttonNext,
          prevEl: this.buttonPrev
        }
      } : {},
      ...this.pagination ? {
        pagination: {
          el: this.pagination,
          clickable: true,
          enabled: true
        }
      } : {}
    });
  }
}
customElements.define("original-slider", OriginalSlider);
class OriginalVariantSelects extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues
        }
      });
    });
  }
  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options).find((option) => option.getAttribute("selected")).removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target.closest(".js-productFormInput").querySelector("[data-selected-value] > .js-swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty("--swatch--background", swatchValue);
        selectedDropdownSwatchValue.classList.remove("is-unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty("--swatch--background", "unset");
        selectedDropdownSwatchValue.classList.add("is-unavailable");
      }
      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target.closest(`.js-productFormInput`).querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }
  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }
  get selectedOptionValues() {
    return Array.from(this.querySelectorAll("select option[selected], fieldset input:checked")).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}
customElements.define("original-variant-selects", OriginalVariantSelects);
document.addEventListener("DOMContentLoaded", floatingMenuDisplayControl, false);
window.addEventListener("scroll", floatingMenuDisplayControl, false);
if (TO_TOP) {
  TO_TOP.addEventListener("click", toTop, false);
}
if (HAMBURGER) {
  HAMBURGER.addEventListener("click", drawerDisplayControl, false);
}
if (FULL_SCREEN_OVERLAY) {
  FULL_SCREEN_OVERLAY.addEventListener("click", drawerDisplayControl, false);
}
document.addEventListener("DOMContentLoaded", linkWithinPageControl, false);
function getQueryRoot(root) {
  return root && root.nodeType === 1 ? root : document;
}
function disconnectSliderResizeObserver(el) {
  if (el._originalSliderResizeObserver) {
    el._originalSliderResizeObserver.disconnect();
    el._originalSliderResizeObserver = null;
  }
}
function attachSliderResizeObserver(el, callback) {
  disconnectSliderResizeObserver(el);
  const ro = new ResizeObserver(callback);
  ro.observe(el);
  el._originalSliderResizeObserver = ro;
}
function initFeaturedBannerSliders(root) {
  const sliders = getQueryRoot(root).querySelectorAll('original-slider[data-slider="featured-banner"]');
  const options = {
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 16,
    breakpoints: {
      750: {
        spaceBetween: 17
      }
    }
  };
  sliders.forEach(function(el) {
    if (el.initializeSlider) {
      el.initializeSlider(options);
      el.classList.add("is-initialized");
    }
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFeaturedBannerSliders, false);
} else {
  initFeaturedBannerSliders();
}
function initCollectionTabsSliders(root) {
  const sliders = getQueryRoot(root).querySelectorAll('original-slider[data-slider="collection-tabs"]');
  const options = {
    slidesPerView: "auto",
    spaceBetween: 8,
    loop: false
  };
  sliders.forEach(function(el) {
    if (el.initializeSlider) {
      el.initializeSlider(options);
      el.classList.add("is-initialized");
    }
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCollectionTabsSliders, false);
} else {
  initCollectionTabsSliders();
}
function getCollectionSectionId(sliderEl) {
  const id = sliderEl.id || "";
  return id.replace(/^js-collection-slider--/, "").replace(/-\d+$/, "");
}
function updateCollectionNavPositionForSection(slidersInSection) {
  if (slidersInSection.length === 0) return;
  const firstSlider = slidersInSection[0];
  const media = firstSlider.querySelector(".swiper-slide .c-card-product__media");
  if (media && media.offsetHeight > 0) {
    const navTopValue = media.offsetHeight / 2 + "px";
    slidersInSection.forEach(function(el) {
      el.style.setProperty("--collection-nav-top", navTopValue);
    });
  }
}
function initCollectionSliders(root) {
  const sliders = getQueryRoot(root).querySelectorAll('original-slider[id^="js-collection-slider--"]');
  if (sliders.length === 0) return;
  const options = {
    slidesPerView: "auto",
    spaceBetween: 12,
    loop: false,
    breakpoints: {
      750: {
        slidesPerView: 5,
        spaceBetween: 16
      }
    }
  };
  const slidersBySection = {};
  sliders.forEach(function(el) {
    disconnectSliderResizeObserver(el);
    if (el.initializeSlider) {
      el.initializeSlider(options);
      el.classList.add("is-initialized");
    }
    const sectionId = getCollectionSectionId(el);
    if (!slidersBySection[sectionId]) slidersBySection[sectionId] = [];
    slidersBySection[sectionId].push(el);
  });
  function updateAllSectionsNavPosition() {
    Object.keys(slidersBySection).forEach(function(sectionId) {
      updateCollectionNavPositionForSection(slidersBySection[sectionId]);
    });
  }
  updateAllSectionsNavPosition();
  requestAnimationFrame(function() {
    requestAnimationFrame(updateAllSectionsNavPosition);
  });
  sliders.forEach(function(el) {
    attachSliderResizeObserver(el, function() {
      if (el.sliderInstance) {
        el.sliderInstance.update();
      }
      updateAllSectionsNavPosition();
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCollectionSliders, false);
} else {
  initCollectionSliders();
}
function getRankingSectionId(sliderEl) {
  const id = sliderEl.id || "";
  return id.replace(/^js-ranking-slider--/, "").replace(/-\d+$/, "");
}
function updateRankingNavPositionForSection(slidersInSection) {
  if (slidersInSection.length === 0) return;
  const firstSlider = slidersInSection[0];
  const media = firstSlider.querySelector(".swiper-slide .c-card-product__media");
  if (media && media.offsetHeight > 0) {
    const navTopValue = media.offsetHeight / 2 + "px";
    slidersInSection.forEach(function(el) {
      el.style.setProperty("--collection-nav-top", navTopValue);
    });
  }
}
function initRankingSliders(root) {
  const sliders = getQueryRoot(root).querySelectorAll('original-slider[id^="js-ranking-slider--"]');
  if (sliders.length === 0) return;
  const options = {
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: false,
    breakpoints: {
      750: {
        slidesPerView: 5,
        spaceBetween: 0
      }
    }
  };
  const slidersBySection = {};
  sliders.forEach(function(el) {
    disconnectSliderResizeObserver(el);
    if (el.initializeSlider) {
      el.initializeSlider(options);
      el.classList.add("is-initialized");
    }
    const sectionId = getRankingSectionId(el);
    if (!slidersBySection[sectionId]) slidersBySection[sectionId] = [];
    slidersBySection[sectionId].push(el);
  });
  function updateAllSectionsNavPosition() {
    Object.keys(slidersBySection).forEach(function(sectionId) {
      updateRankingNavPositionForSection(slidersBySection[sectionId]);
    });
  }
  updateAllSectionsNavPosition();
  requestAnimationFrame(function() {
    requestAnimationFrame(updateAllSectionsNavPosition);
  });
  sliders.forEach(function(el) {
    attachSliderResizeObserver(el, function() {
      if (el.sliderInstance) {
        el.sliderInstance.update();
      }
      updateAllSectionsNavPosition();
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initRankingSliders, false);
} else {
  initRankingSliders();
}
function initMediaAwardsSliders(root) {
  const sliders = getQueryRoot(root).querySelectorAll('original-slider[data-slider="media-awards"]');
  const options = {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: false,
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 24
      }
    }
  };
  sliders.forEach(function(el) {
    if (el.initializeSlider) {
      el.initializeSlider(options);
      el.classList.add("is-initialized");
    }
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMediaAwardsSliders, false);
} else {
  initMediaAwardsSliders();
}
function updateStoreLocatorNavPosition(sliderEl) {
  const media = sliderEl.querySelector(".swiper-slide .p-store-locator__card-image");
  if (media && media.offsetHeight > 0) {
    sliderEl.style.setProperty("--store-locator-nav-top", media.offsetHeight / 2 + "px");
  }
}
function initStoreLocatorSliders(root) {
  const sliders = getQueryRoot(root).querySelectorAll('original-slider[id^="js-store-locator-slider--"]');
  if (sliders.length === 0) return;
  const options = {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: false,
    watchOverflow: true,
    breakpoints: {
      750: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    }
  };
  sliders.forEach(function(el) {
    disconnectSliderResizeObserver(el);
    if (el.initializeSlider) {
      el.initializeSlider(options);
      el.classList.add("is-initialized");
    }
    updateStoreLocatorNavPosition(el);
  });
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      sliders.forEach(updateStoreLocatorNavPosition);
    });
  });
  sliders.forEach(function(el) {
    attachSliderResizeObserver(el, function() {
      if (el.sliderInstance) {
        el.sliderInstance.update();
      }
      updateStoreLocatorNavPosition(el);
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initStoreLocatorSliders, false);
} else {
  initStoreLocatorSliders();
}
function updateProductsCategoryNavPositionForSection(slidersInSection) {
  if (slidersInSection.length === 0) return;
  const firstSlider = slidersInSection[0];
  const media = firstSlider.querySelector(".swiper-slide .p-products-category__card-media");
  if (media && media.offsetHeight > 0) {
    const navTopValue = media.offsetHeight / 2 + "px";
    slidersInSection.forEach(function(el) {
      el.style.setProperty("--products-category-nav-top", navTopValue);
    });
  }
}
function initProductsCategorySliders(root) {
  const sliders = getQueryRoot(root).querySelectorAll('original-slider[id^="js-products-category-slider--"]');
  if (sliders.length === 0) return;
  const options = {
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: false,
    breakpoints: {
      750: {
        slidesPerView: 4,
        spaceBetween: 0
      }
    }
  };
  const slidersBySection = {};
  sliders.forEach(function(el) {
    disconnectSliderResizeObserver(el);
    if (el.initializeSlider) {
      el.initializeSlider(options);
      el.classList.add("is-initialized");
    }
    const id = el.id || "";
    const sectionId = id.replace(/^js-products-category-slider--/, "");
    if (!slidersBySection[sectionId]) slidersBySection[sectionId] = [];
    slidersBySection[sectionId].push(el);
  });
  function updateAllSectionsNavPosition() {
    Object.keys(slidersBySection).forEach(function(sectionId) {
      updateProductsCategoryNavPositionForSection(slidersBySection[sectionId]);
    });
  }
  updateAllSectionsNavPosition();
  requestAnimationFrame(function() {
    requestAnimationFrame(updateAllSectionsNavPosition);
  });
  sliders.forEach(function(el) {
    attachSliderResizeObserver(el, function() {
      if (el.sliderInstance) {
        el.sliderInstance.update();
      }
      updateAllSectionsNavPosition();
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductsCategorySliders, false);
} else {
  initProductsCategorySliders();
}
function initBlogSliders(root) {
  const sliders = getQueryRoot(root).querySelectorAll('original-slider[id^="js-blog-slider--"]');
  const options = {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: false,
    breakpoints: {
      750: {
        slidesPerView: 4
        // spaceBetween: 24,
      }
    }
  };
  sliders.forEach(function(el) {
    if (el.initializeSlider) {
      el.initializeSlider(options);
      el.classList.add("is-initialized");
    }
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBlogSliders, false);
} else {
  initBlogSliders();
}
function getRecentlyViewedSectionId(sliderEl) {
  const id = sliderEl.id || "";
  return id.replace(/^js-(?:recently-viewed|related-products|product-recommendations)-slider--/, "");
}
function updateRecentlyViewedNavPositionForSection(slidersInSection) {
  if (slidersInSection.length === 0) return;
  const firstSlider = slidersInSection[0];
  const media = firstSlider.querySelector(".swiper-slide .c-card-product__media");
  if (media && media.offsetHeight > 0) {
    const navTopValue = media.offsetHeight / 2 + "px";
    slidersInSection.forEach(function(el) {
      el.style.setProperty("--recently-viewed-nav-top", navTopValue);
    });
  }
}
function initRecentlyViewedSliders(root) {
  const sliders = getQueryRoot(root).querySelectorAll(
    'original-slider[id^="js-recently-viewed-slider--"], original-slider[id^="js-related-products-slider--"], original-slider[id^="js-product-recommendations-slider--"]'
  );
  if (sliders.length === 0) return;
  const options = {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: false,
    breakpoints: {
      750: {
        slidesPerView: 4,
        spaceBetween: 24
      }
    }
  };
  const slidersBySection = {};
  sliders.forEach(function(el) {
    disconnectSliderResizeObserver(el);
    if (el.initializeSlider) {
      el.initializeSlider(options);
      el.classList.add("is-initialized");
    }
    const sectionId = getRecentlyViewedSectionId(el);
    if (!slidersBySection[sectionId]) slidersBySection[sectionId] = [];
    slidersBySection[sectionId].push(el);
  });
  function updateAllSectionsNavPosition() {
    Object.keys(slidersBySection).forEach(function(sectionId) {
      updateRecentlyViewedNavPositionForSection(slidersBySection[sectionId]);
    });
  }
  setTimeout(function() {
    updateAllSectionsNavPosition();
  }, 300);
  requestAnimationFrame(function() {
    requestAnimationFrame(updateAllSectionsNavPosition);
  });
  sliders.forEach(function(el) {
    attachSliderResizeObserver(el, function() {
      if (el.sliderInstance) {
        el.sliderInstance.update();
      }
      updateAllSectionsNavPosition();
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initRecentlyViewedSliders, false);
} else {
  initRecentlyViewedSliders();
}
function initSlideshowSliders(root) {
  const SLIDESHOW_THUMB_ID_PREFIX = "js-slideshow-thumbnail--";
  const SLIDESHOW_MAIN_ID_PREFIX = "js-slideshow--";
  const thumbnailSliders = getQueryRoot(root).querySelectorAll(
    'original-slider[id^="' + SLIDESHOW_THUMB_ID_PREFIX + '"]'
  );
  if (thumbnailSliders.length === 0) return;
  thumbnailSliders.forEach(function(thumbnailEl) {
    const sectionId = thumbnailEl.id.slice(SLIDESHOW_THUMB_ID_PREFIX.length);
    const mainSliderEl = document.getElementById(SLIDESHOW_MAIN_ID_PREFIX + sectionId);
    if (!mainSliderEl || !thumbnailEl.initializeSlider) return;
    const sectionWrap = thumbnailEl.closest(".p-slideshow") || thumbnailEl.closest(".p-slideshow-thumbnail");
    const slideCount = sectionWrap && sectionWrap.dataset.slideCount ? parseInt(sectionWrap.dataset.slideCount, 10) : 4;
    const useLoop = slideCount >= 4;
    const thumbOptions = {
      slidesPerView: "auto",
      spaceBetween: 16,
      loop: useLoop,
      speed: 1e3
    };
    thumbnailEl.initializeSlider(thumbOptions);
    if (!thumbnailEl.sliderInstance) return;
    const mainOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: useLoop,
      speed: 1e3,
      thumbs: {
        swiper: thumbnailEl.sliderInstance
      },
      autoplay: {
        delay: 4e3,
        disableOnInteraction: false,
        waitForTransition: false
      },
      breakpoints: {
        750: {
          pagination: {
            enabled: false
          }
        }
      }
    };
    mainSliderEl.initializeSlider(mainOptions);
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSlideshowSliders, false);
} else {
  initSlideshowSliders();
}
function initOriginalSectionSlidersFromEditor(event) {
  const root = event && event.target && event.target.nodeType === 1 ? event.target : document;
  requestAnimationFrame(function() {
    initFeaturedBannerSliders(root);
    initCollectionTabsSliders(root);
    initCollectionSliders(root);
    initRankingSliders(root);
    initMediaAwardsSliders(root);
    initStoreLocatorSliders(root);
    initProductsCategorySliders(root);
    initBlogSliders(root);
    initRecentlyViewedSliders(root);
    initSlideshowSliders(root);
  });
}
document.addEventListener("shopify:section:load", initOriginalSectionSlidersFromEditor, false);
document.addEventListener("shopify:section:reorder", function() {
  requestAnimationFrame(function() {
    initOriginalSectionSlidersFromEditor({ target: document });
  });
}, false);
